import { cn } from '@/lib/utils';

/**
 * Centred message shell for "you can't see this" pages — 404, no-shops,
 * access-denied. Replaces the dashboard-shared `RestrictedPage` so we don't
 * pull in the legacy `@nearst/ui` global stylesheet.
 */
export function RestrictedPage({ children, className }) {
	return (
		<main className={cn('flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-6 text-center', className)}>
			{children}
		</main>
	);
}
